import React from "react";
import Proptypes from "prop-types";

import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { LogosWrapper } from "./style";

const Logos = ({ header, logoUrls, showInTabletAndMobile, flexView }) => {
	return (
		<LogosWrapper showInTabletAndMobile={showInTabletAndMobile}>
			<h2 className="header">{header}</h2>
			{!flexView ? (
				<div className="logos-container">
					{logoUrls.map((url, index) => (
						<CloudinaryImage
							key={`${url}-${index}`}
							url={url}
							lazyload
							sizes={{ default: { height: 45 }, "322px": { height: 45 } }}
						/>
					))}
				</div>
			) : (
				<div className="logos-container-flex">
					{logoUrls.map((url, index) => (
						<CloudinaryImage
							key={`${url}-${index}`}
							url={url}
							lazyload
							sizes={{ default: { height: 80 }, "322px": { height: 80 } }}
						/>
					))}
				</div>
			)}
		</LogosWrapper>
	);
};

Logos.propTypes = {
	header: Proptypes.string,
	logoUrls: Proptypes.arrayOf(Proptypes.string),
	showInTabletAndMobile: Proptypes.bool,
	flexView: Proptypes.bool,
};

Logos.defaultProps = {
	header: "",
	logoUrls: [],
	showInTabletAndMobile: true,
	flexView: false,
};

export default Logos;
